import * as React from "react";
import { ChatUIStage, Message } from "../../types";
import ChattingLauncher from "./ChattingLauncher";
import AvailableLauncher from "./AvailableLauncher";
import UnavailableLauncher from "./UnavailableLauncher";
import Eyecatcher from "../Eyecatcher";

interface Props {
  chatIsAssigned: boolean;
  isChatAvailable: boolean;
  unreadMessages: Array<Message>;
  agentHeadshotUrl: string;
  eyecatcherDismissed: boolean;
  messagePreviewDisabled: boolean;
  onExpand: () => void;
  onDismissEyecatcher: () => void;
  onCloseMessagePreview: () => void;
}

class Launcher extends React.Component<Props, {}> {
  public renderLauncher() {
    if (this.props.chatIsAssigned) {
      return (
        <ChattingLauncher
          agentHeadshotUrl={this.props.agentHeadshotUrl}
          unreadMessages={this.props.unreadMessages}
          messagePreviewDisabled={this.props.messagePreviewDisabled}
          onExpand={this.props.onExpand}
          onCloseMessagePreview={this.props.onCloseMessagePreview}
        />
      );
    } else if (this.props.isChatAvailable) {
      return <AvailableLauncher onExpand={this.props.onExpand} />;
    } else {
      return <UnavailableLauncher onExpand={this.props.onExpand} />;
    }
  }

  public renderEyecatcher() {
    if (this.props.eyecatcherDismissed) {
      return null;
    }

    if (this.props.chatIsAssigned) {
      return null;
    }

    return (
      <Eyecatcher
        isChatAvailable={this.props.isChatAvailable}
        onDismiss={this.props.onDismissEyecatcher}
        onClick={this.props.onExpand}
      />
    );
  }

  public render() {
    return (
      <div className="velaro-launcher-container">
        {this.renderEyecatcher()}
        {this.renderLauncher()}
      </div>
    );
  }
}

export default Launcher;
